import PaymentCard, {
  CreditCardType,
  PaymentCardPropsTypes,
} from './PaymentCard';

export type {PaymentCardPropsTypes};
export {CreditCardType};
export default PaymentCard;
